import { useState } from "react";
import { Label } from "@/components/ui/label";
import Footer from "@/components/shared/Footer";

const SavingsPage = () => {
  const [caseVolume, setCaseVolume] = useState(20);
  const [avgCaseValue, setAvgCaseValue] = useState(250000);
  
  const monthlySavings = Math.round(caseVolume * 8 * 150); // 8 hours saved per case at $150/hr
  const settlementIncrease = Math.round(caseVolume * avgCaseValue * 0.06); // 6% settlement increase
  const annualROI = Math.round(((monthlySavings * 12 + settlementIncrease) / (499 * 12 + 599)) * 100); // Using sale price $499/mo

  return (
    <main className="min-h-screen" style={{ background: '#F8FAFC' }}>
      <div className="container-shell py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2.5 px-3.5 py-2.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-4"
            style={{ background: '#fff', border: '1px solid #D9E4F2', color: '#416588' }}>
            <span className="w-2 h-2 rounded-full" style={{ background: 'linear-gradient(135deg,#1D4ED8,#3B82F6,#14B8A6)' }}></span>
            ROI Calculator
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#1E293B' }}>Calculate Your Savings</h1>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#475569' }}>
            See the financial impact Trialeze can have on your practice.
          </p>
        </div>
        
        {/* Calculator */}
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div className="rounded-3xl p-8" style={{ background: '#fff', border: '1px solid #D9E4F2', boxShadow: '0 12px 30px rgba(15,23,42,.08)' }}>
              <h3 className="text-lg font-bold mb-6" style={{ color: '#1E293B' }}>Your Practice</h3>
              <div className="space-y-6">
                <div>
                  <Label className="flex justify-between" style={{ color: '#1E293B' }}>
                    <span>Monthly Case Volume</span>
                    <span className="font-bold">{caseVolume} cases</span>
                  </Label>
                  <input type="range" min="5" max="100" value={caseVolume} onChange={(e) => setCaseVolume(Number(e.target.value))} 
                    className="w-full mt-2 h-2 rounded-full appearance-none cursor-pointer" style={{ background: '#E7EEF7' }} />
                </div>
                <div>
                  <Label className="flex justify-between" style={{ color: '#1E293B' }}>
                    <span>Average Case Value</span>
                    <span className="font-bold">${(avgCaseValue/1000).toFixed(0)}K</span>
                  </Label>
                  <input type="range" min="50000" max="1000000" step="10000" value={avgCaseValue} onChange={(e) => setAvgCaseValue(Number(e.target.value))} 
                    className="w-full mt-2 h-2 rounded-full appearance-none cursor-pointer" style={{ background: '#E7EEF7' }} />
                </div>
              </div>
            </div>
            
            <div className="rounded-3xl p-8" style={{ background: 'linear-gradient(135deg,#1D4ED8,#3B82F6)', boxShadow: '0 20px 42px rgba(29,78,216,.25)' }}>
              <h3 className="text-lg font-bold mb-6 text-white">Your Projected Savings</h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center py-3" style={{ borderBottom: '1px solid rgba(255,255,255,.2)' }}>
                  <span className="text-blue-200">Monthly time savings value</span>
                  <span className="text-xl font-bold text-white">${monthlySavings.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center py-3" style={{ borderBottom: '1px solid rgba(255,255,255,.2)' }}>
                  <span className="text-blue-200">Annual settlement increase</span>
                  <span className="text-xl font-bold text-white">${settlementIncrease.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center py-3">
                  <span className="text-blue-200">Annual ROI</span>
                  <span className="text-3xl font-extrabold text-emerald-300">{annualROI}%</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Savings Breakdown Chart */}
          <div className="rounded-3xl p-8" style={{ background: '#fff', border: '1px solid #D9E4F2', boxShadow: '0 12px 30px rgba(15,23,42,.08)' }}>
            <h3 className="text-lg font-bold mb-6" style={{ color: '#1E293B' }}>12-Month Projected Value</h3>
            <div className="flex items-end justify-between h-48 gap-4">
              {Array.from({length: 12}, (_, i) => {
                const monthValue = (monthlySavings * (i + 1) + (settlementIncrease / 12) * (i + 1)) / 1000;
                const height = Math.min((monthValue / ((monthlySavings * 12 + settlementIncrease) / 1000)) * 100, 100);
                return (
                  <div key={i} className="flex-1 flex flex-col items-center">
                    <div className="w-full rounded-t transition-all" style={{ 
                      height: `${height}%`, 
                      background: 'linear-gradient(180deg,#3B82F6,#1D4ED8)',
                      minHeight: '8px'
                    }} />
                    <span className="text-xs mt-2" style={{ color: '#475569' }}>M{i + 1}</span>
                  </div>
                );
              })}
            </div>
            <div className="mt-6 text-center">
              <span className="text-2xl font-extrabold" style={{ color: '#1E293B' }}>
                ${((monthlySavings * 12 + settlementIncrease) / 1000).toFixed(0)}K
              </span>
              <span className="ml-2" style={{ color: '#475569' }}>projected annual value</span>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default SavingsPage;
